import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import lgZoom from "lightgallery/plugins/zoom";
import styled from "styled-components";
import Masonry from "react-responsive-masonry";
import React, {useEffect, useState} from "react";
import {fetchAlbumData} from "../serverAPI";

const GalleryContainer = styled.div`
  img {
    width: 100%;
    height: auto;
    cursor: pointer;
  }
`;

export default function Album() {
  const [images, setImages] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const imagesData = await fetchAlbumData();
      setImages(imagesData);
    }

    fetchData();
  }, []);

  return (<div>
    <LightGallery speed={500} plugins={[lgZoom]} download={false} zoom={false} counter={false} selector="a">
      <GalleryContainer>
        <Masonry columnsCount={4} gutter={"10px"}>
          {images.map((image, index) => (<a href={image.path} key={index}>
            <img src={image.path} alt={image.info}/>
          </a>))}
        </Masonry>
      </GalleryContainer>
    </LightGallery>
  </div>);
}
